import { useStore } from '@/containers'
import { type Menu as MenuType } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Image from 'next/image'
import Link from 'next/link'
import Menu, { MenuItem, SubMenu } from 'rc-menu'
import 'rc-menu/assets/index.css'
import { useEffect, useRef, useState } from 'react'
import ImageOptimize from '../ImageOptimize'

const DEFAULT_HIGHLIGHT = 0
interface CateDropdownProps {
  items: MenuType[]
  showIcon?: boolean
  className?: string
  popupClassName?: string
}
const CateDropdown = ({
  items,
  className,
  popupClassName,
}: CateDropdownProps) => {
  const ref = useRef<HTMLInputElement>(null)
  const { setIsOpenShare } = useStore()
  const [height, setHeight] = useState<number>(0)

  useEffect(() => {
    const height =
      document.getElementById('main-mega-menu-items')?.clientHeight || 0
    setHeight(height <= 8 ? 0 : height - 8)
  }, [])

  return (
    <div className={`${className}`} ref={ref}>
      <Menu
        triggerSubMenuAction='hover'
        className='menuCS overflow-hidden !text-black-400'
        defaultOpenKeys={['0']}
      >
        {items &&
          items.map((e, index) => (
            <SubMenu
              popupStyle={{ height: height ? height + 'px' : 'auto' }}
              popupClassName={`border-l-[#F3F4F6] border-l-[7px] z-[999] !top-[84px] subMenuCS ${popupClassName}`}
              key={index}
              title={
                <div className='relative flex h-full items-center gap-3 px-4 py-3 text-left hover:bg-[#FFFBEB]'>
                  <div className='min-w-[24px]'>
                    <ImageOptimize
                      src={e.icon}
                      width={24}
                      height={24}
                      alt={getTranslate(e.name)}
                      priority
                    />
                  </div>
                  <div className='flex w-full whitespace-nowrap'>
                    <div className=''>
                      <Link
                        href={e.url ? e.url : '/'}
                        className={`${
                          index === DEFAULT_HIGHLIGHT ? 'text-red-500' : ''
                        } cursor-pointer text-Headline font-semibold transition-all ease-in hover:text-blue-400`}
                      >
                        {getTranslate(e.name)}
                      </Link>
                      <div className='w-[250px] overflow-hidden text-ellipsis whitespace-nowrap text-mainBody'>
                        {e.children &&
                          e.children
                            ?.filter?.(e => e.highlight)
                            .map((f, index) => (
                              <Link href={f.url || '/'} key={'lv-1-' + index}>
                                <span
                                  key={index}
                                  className=' cursor-pointer hover:text-blue-400'
                                >
                                  {index > 0 && '  -  '}
                                  {getTranslate(f?.name)}
                                </span>
                              </Link>
                            ))}
                      </div>
                    </div>
                  </div>
                </div>
              }
            >
              <MenuItem
                className='!z-[9999] min-h-[450px] w-[928px] !px-6 !py-5 text-dark-400'
                key={`menu-${index}`}
              >
                <div className='flex flex-wrap gap-x-5 gap-y-8 pr-5'>
                  {e.children?.map?.((r, ind) =>
                    ind === 0 ? (
                      <div key={ind} className='w-full'>
                        <h6 className='font-semibold'>
                          {getTranslate(r?.name)}
                        </h6>
                        <div className='mt-3 flex flex-wrap gap-11'>
                          {r.children?.map?.((f, fIndex: number) => (
                            <Link
                              href={f.url ? f.url : '/'}
                              className='flex w-20 flex-col items-center gap-2'
                              key={'lv-3-' + fIndex}
                            >
                              <ImageOptimize
                                src={
                                  f.icon ||
                                  '/assets/images/product-default-image.jpg'
                                }
                                alt={getTranslate(f.name)}
                                className='h-16 w-16 bg-contain'
                              />
                              <span className='block cursor-pointer whitespace-normal text-center text-mainBody font-normal !leading-[20px] hover:text-blue-400'>
                                {getTranslate(f.name)}
                              </span>
                            </Link>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div
                        key={ind}
                        className='w-[calc(25%-26px)] whitespace-normal'
                      >
                        <Link href={r.url ? r.url : '/'} key={ind}>
                          <span className='flex gap-1.5 font-semibold'>
                            {getTranslate(r?.name)}
                            {r.icon && (
                              <Image
                                width={24}
                                height={24}
                                alt={getTranslate(r.name) || ''}
                                src={r.icon}
                                className='h-4 w-4'
                                priority
                              />
                            )}
                          </span>
                        </Link>
                        <div className='mt-2 flex flex-col gap-2'>
                          {r.children &&
                            r.children.map((f, fIndex: number) => (
                              <Link
                                href={f.url ? f.url : '/'}
                                key={'lv-3-' + fIndex}
                              >
                                <span className='cursor-pointer text-mainBody font-normal !leading-[20px] hover:text-blue-400'>
                                  {getTranslate(f.name)}
                                </span>
                              </Link>
                            ))}
                        </div>
                      </div>
                    )
                  )}
                </div>
              </MenuItem>
            </SubMenu>
          ))}
        <SubMenu
          key='/search-order'
          className='text-left'
          title={
            <Link
              className='border-top mt-1 block border-t border-[#E4E4E4] px-4 py-2 pt-5 font-normal hover:text-primary'
              href='/search-order'
            >
              Tra cứu đơn hàng
            </Link>
          }
        />
        <SubMenu
          className='text-left'
          key='/post/chinh-sach'
          title={
            <Link
              className='border-top block px-4 py-2 font-normal hover:text-primary'
              href='/post/chinh-sach'
            >
              Chính sách Bảo hành & Đổi/trả
            </Link>
          }
        />
        <SubMenu
          className='text-left'
          key='/post?type=promotion'
          title={
            <Link
              className='border-top block px-4 py-2 font-normal hover:text-primary'
              href='/post?type=promotion'
            >
              Tin tức/Khuyến mãi
            </Link>
          }
        />
        <SubMenu
          className='text-left'
          key='share-izl'
          title={
            <div
              className='border-top mb-6 block px-4 py-2 pb-6 font-normal hover:text-primary'
              onClick={() => setIsOpenShare(true)}
            >
              Chia sẻ với người thân
            </div>
          }
        />
      </Menu>
    </div>
  )
}
export default CateDropdown
